import React from "react";
import { classNames } from "../../helper/classNames";
import CollapseTable from "./CollapseTable";

const btns = [
  "mcu",
  "bettery",
  "sensor",
  "data acqusition",
  "mixed signal",
  "wireless",
  "memory",
  "sensor2",
  "data acqusition-x",
  "mixed",
  "wireless 3.0",
];
const Design = () => {
  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-4 mt-4  md:mt-16">
        {/* Left Side */}
        <div className="col-span-1 shadow-none">
          <div className="md:w-4/5 max-h-[18rem] md:max-h-[32rem] overflow-y-scroll	">
            {btns.map((text, i) => {
              return (
                <div key={text} className="mb-6 mx-16 md:mx-10">
                  <button
                    type="submit"
                    className={classNames(
                      i === 0
                        ? "bg-blue text-white active:bg-blue/90 active:text-white"
                        : "text-blue bg-light/30 active:bg-blue/90 active:text-white",
                      "cursor-pointer	group relative w-full flex justify-center  p-3 border border-transparent rounded-xl  focus:outline-none focus:ring-0 shadow-lg text-lg"
                    )}
                  >
                    {text}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right Side || Table Content */}
        <div className="col-span-3 mt-10 md:mt-0">
          <CollapseTable />
        </div>
      </div>
    </div>
  );
};

export default Design;
